import React, { useState } from "react";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import classes from "./CoachDetailAboutMe.module.css";
import { Button } from "../Button/Button.jsx";
import {
  ForwardArrow,
  UserIconRed,
  StarIconRed,
  SettingsIconRed,
  ChatIconRed,
  BackwardArrow,
} from "../../constant/imagePath";
import PropTypes from "prop-types";
import { LinkButtonWithIcon } from "../LinkButtonWithIcon/LinkButtonWithIcon";

import LinkBtnClasses from "../LinkButtonWithIcon/LinkButtonWithIcon.module.css";
import { ReactSVG } from "react-svg";

export const CoachDetailAboutMe = ({ userData }) => {
  const lists = [
    { title: "Teaches", icon: UserIconRed, data: userData?.skills },
    { title: "Levels Taught", icon: StarIconRed, data: userData?.levels },
    {
      title: "Specialization",
      icon: SettingsIconRed,
      data: userData?.specialization,
    },
    {
      title: "Fast Response Rate",
      icon: ChatIconRed,
      data: userData?.responseRate,
    },
  ];

  const [showMore, setShowMore] = useState(false);

  return (
    <>
      <style jsx>{`
        .${LinkBtnClasses.btnWithIcon}:hover {
          color: ${Colors.neutralShadesOfNero} !important;
        }
        .${LinkBtnClasses.btnWithIcon}:hover img {
          filter: unset !important;
        }
      `}</style>
      <div className={classes.aboutMe}>
        <p
          className={` ${[
            classes.description,
            showMore && classes.unlimitedLines,
          ].join(" ")}`}
          style={{
            ...Fonts.p1,
            color: Colors.neutralShadesOfDimGray,
            marginTop: 24,
          }}
        >
          {userData?.description}
        </p>
        <LinkButtonWithIcon
          text={showMore ? "Show Less" : "Show more"}
          leftIcon={showMore ? BackwardArrow : ForwardArrow}
          customStyle={{ ...Fonts.b1 }}
          onClick={() => {
            setShowMore(!showMore);
          }}
        />
        <ul className={classes.list}>
          {lists?.map((item) => {
            return (
              <li>
                <ReactSVG
                  src={item?.icon}
                  beforeInjection={(svg) => {
                    svg.classList.add(`${[classes.img].join(" ")}`);
                  }}
                />
                <div>
                  <h6
                    style={{
                      ...Fonts.input3,
                      color: Colors.neutralShadesOfDimGray,
                      lineHeight: "20px",
                    }}
                  >
                    {item?.title}:
                  </h6>
                  <h4
                    style={{
                      ...Fonts.h7,
                      fontFamily: "inter-600",
                      lineHeight: "24px",
                      color: Colors.neutralShadesOfNero,
                    }}
                  >
                    {typeof item?.data === "string"
                      ? item?.data
                      : item?.data.join(" , ")}
                  </h4>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};

CoachDetailAboutMe.propTypes = {
  userData: PropTypes.object,
};

CoachDetailAboutMe.defaultProps = {
  userData: {
    description:
      "Hi! I’m John, one of the West Coast's most respected tennis teachers. Since 1970 over 25,000 students have attended my camps and clinics. With a limited enrollment policy, the student-staff ratio is 4-1.  Since 1970 over 25,000 students have attended my camps and clinics demodem doe dmeka jhas hjg ash hasgd ashdg ashdg asgd jgsadgh ashdh ashdg as hasn dsa dhg ashdg hasg dhasdhasgdh sdg gsad ghsad gsad Hi! I’m John, one of the West Coast's most respected tennis teachers. Since 1970 over 25,000 students have attended my camps and clinics. With a limited enrollment policy, the student-staff ratio is 4-1.  Since 1970 over 25,000 students have attended my camps and clinics demodem doe dmeka jhas hjg ash hasgd ashdg ashdg asgd jgsadgh ashdh ashdg as hasn dsa dhg ashdg hasg dhasdhasgdh sdg gsad ghsad gsad Hi! I’m John, one of the West Coast's most respected tennis teachers. Since 1970 over 25,000 students have attended my camps and clinics. With a limited enrollment policy, the student-staff ratio is 4-1.  Since 1970 over 25,000 students have attended my camps and clinics demodem doe dmeka jhas hjg ash hasgd ashdg ashdg asgd jgsadgh ashdh ashdg as hasn dsa dhg ashdg hasg dhasdhasgdh sdg gsad ghsad gsad",
    levels: ["Beginners", "Intermediate", "Advanced"],
    skills: ["Kids", "Juniors", "Adults", "Seniors"],
    specialization: ["Forehand", "backhand", "Top spin"],
    responseRate: "100%",
  },
};
